'use client';

import { css } from '@repo/pandacss/styled-system/css';
import { useState } from 'react';
import { MdClose as CloseIcon } from 'react-icons/md';

export function EditorialIntegrity() {
  const [showDiscloser, setShowDiscloser] = useState(false);

  const handleClick = () => {
    setShowDiscloser(true);
  };

  const closeModal = () => {
    setShowDiscloser(false);
  };

  return (
    <>
      <button
        onClick={handleClick}
        type="button"
        className={css({
          backgroundColor: 'transparent',
          borderTopStyle: 'none',
          borderRightStyle: 'none',
          borderBottomStyle: 'none',
          borderLeftStyle: 'none',
          cursor: 'pointer',
          paddingTop: '0',
          paddingRight: '0',
          paddingBottom: '0',
          paddingLeft: '0',
          textStyle: 'notesHighlightSmall',
          color: 'lime.tintLP2',
          _hover: {
            color: 'neutral.white',
          },
        })}
      >
        Editorial Integrity
      </button>

      {showDiscloser && (
        <div
          className={css({
            position: 'fixed',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            backgroundColor: '[rgba(0, 0, 0, 0.5)]',
            zIndex: '[1300]',
          })}
          role="dialog"
          aria-modal="true"
          aria-labelledby="editorial-integrity-title"
          onClick={closeModal}
        >
          <div
            className={css({
              backgroundColor: 'white',
              paddingTop: '6',
              paddingBottom: { base: '10', md: '20' },
              width: 'full',
              borderTopLeftRadius: '[8px]',
              borderTopRightRadius: '[8px]',
              borderBottomRightRadius: '[0]',
              borderBottomLeftRadius: '[0]',
              boxShadow: '[0px -4px 4px 0px #00000026]',
              color: 'black',
            })}
            onClick={e => e.stopPropagation()}
          >
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '[1280px]',
                paddingInlineStart: { base: '4', md: '12' },
                paddingInlineEnd: { base: '4', md: '12' },
                marginInlineStart: 'auto',
                marginInlineEnd: 'auto',
              })}
            >
              <div
                className={css({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: { base: 'flex-start', md: 'center' },
                  marginBottom: '6',
                })}
              >
                <span
                  className={css({
                    marginTop: '0',
                    marginRight: '0',
                    marginBottom: '0',
                    marginLeft: '0',
                    textStyle: 'textLargeBold',
                  })}
                  id="editorial-integrity-title"
                >
                  NerdWallet is committed to editorial integrity
                </span>
                <button
                  onClick={closeModal}
                  type="button"
                  className={css({
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '10',
                    height: '10',
                    marginLeft: '6',
                    backgroundColor: 'transparent',
                    borderTopStyle: 'none',
                    borderRightStyle: 'none',
                    borderBottomStyle: 'none',
                    borderLeftStyle: 'none',
                    cursor: 'pointer',
                    color: '[rgba(0, 0, 0, 0.54)]',
                    fontSize: 'xxl',
                    _hover: {
                      backgroundColor: '[rgba(0, 0, 0, 0.04)]',
                      borderTopLeftRadius: 'half',
                      borderTopRightRadius: 'half',
                      borderBottomRightRadius: 'half',
                      borderBottomLeftRadius: 'half',
                    },
                  })}
                  aria-label="Close modal"
                >
                  <CloseIcon />
                </button>
              </div>
              <p
                className={css({
                  marginTop: '0',
                  marginRight: '0',
                  marginBottom: '0',
                  marginLeft: '0',
                  textStyle: 'body',
                  fontWeight: {
                    base: 'normal',
                    md: 'light',
                  },
                })}
              >
                Many or all of the products on this page are from partners who compensate us when
                you click to or take an action on their website,{' '}
                <strong className={css({ fontWeight: 'bold' })}>
                  but this does not influence our evaluations or ratings. Our opinions are our own.
                </strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
